/* unplugin-vue-components disabled */import { render } from "./DetailsRow.vue?vue&type=template&id=517cca0e&ts=true"
import script from "./DetailsRow.vue?vue&type=script&lang=ts"
export * from "./DetailsRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__